import React, { useEffect, useRef, useState } from 'react'
import UserContext from "../userContext";

// Images
import logo from '../images/mypacomefavicon.svg'

import { Button, Modal } from 'react-bootstrap'

function getSavedInventory() {
    const raw = localStorage.getItem('savedFormData');
    if (!raw) return null;

    try {
        const parsed = JSON.parse(raw);
        if (parsed?.inventory && typeof parsed.inventory === 'string') {
            return { ...parsed, inventory: JSON.parse(parsed.inventory) };
        }
        return parsed;
    } catch (error) {
        console.error('Invalid savedFormData payload:', error);
        return null;
    }
}

export default function Header() {
    const userContext = React.useContext(UserContext)
    const [showModal, setShowModal] = useState(false)
    const [showDropdown, setShowDropdown] = useState(false)
    const dropdownRef = useRef(null)

    const handleClose = () => setShowModal(false)
    const handleShow = () => setShowModal(true)

    const localInventory = getSavedInventory();

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [])

    const validateAndSendInventory = async () => {
        const savedInventory = getSavedInventory();
        if (savedInventory) {

            if (navigator.onLine) {
                try {
                    const fd = new FormData();
                    if (savedInventory.inventory) {
                        fd.append('inventory', JSON.stringify(savedInventory.inventory));
                    }
                    fd.append('id', savedInventory.id);
                    if (savedInventory.report) fd.append('report', savedInventory.report);
                    if (savedInventory.files) {
                        for (let i = 0; i < savedInventory.files.length; i++) {
                            fd.append('files', savedInventory.files[i]);
                        }
                    }
                    await userContext.apiReducer('validate', fd);
                    localStorage.removeItem('savedFormData');
                    alert("L'état des lieux a bien été envoyé !");
                    window.location.reload();
                } catch (error) {
                    console.error("Erreur pendant l'envoi:", error);
                }
            } else {
                alert('Vous êtes hors ligne. Réessayez quand vous serez en ligne.');
            }
        }
    }

    return (
        <>
            <header className="app-header">
                <nav className="navbar">
                    <a href="/" className="navbar-brand">
                        <img src={logo} alt="MYPacôme" className="brand-logo" />
                        <div className="brand-info">
                            <span className="brand-text">MYPacôme</span>
                            <span className="user-name">{userContext.user?.name} {userContext.user?.lastName}</span>
                        </div>
                    </a>

                    <div className="navbar-actions">
                        {localInventory && (
                            <button className="offline-btn" onClick={handleShow}>
                                <i className="fas fa-wifi" />
                                <span className="btn-text">En attente</span>
                            </button>
                        )}

                        <div className="user-menu" ref={dropdownRef}>
                            <button
                                className="avatar-btn"
                                onClick={() => setShowDropdown(!showDropdown)}
                            >
                                <img
                                    src={userContext.user?.photo || logo}
                                    alt="Profile"
                                    className="user-avatar"
                                />
                            </button>

                            <div className={`dropdown-menu ${showDropdown ? 'show' : ''}`}>
                                <button className="dropdown-item" disabled>
                                    <i className="fas fa-user" />
                                    <span>Profil</span>
                                </button>
                                <button className="dropdown-item" disabled>
                                    <i className="fas fa-cog" />
                                    <span>Paramètres</span>
                                </button>
                                <div className="dropdown-divider" />
                                <button
                                    className="dropdown-item dropdown-item--danger"
                                    onClick={() => userContext.logout()}
                                >
                                    <i className="fas fa-sign-out-alt" />
                                    <span>Déconnexion</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </nav>
            </header>

            <Modal show={showModal} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <i className="fas fa-wifi mr-2" />
                        États des lieux en attente
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Les éléments suivants seront envoyés dès que vous aurez une connexion internet :</p>
                    <ul className="pending-list">
                        {localInventory?.entree && (
                            <li>
                                <strong>Entrée</strong><br />
                                {localInventory.entree['in-start']}<br />
                                <small>{localInventory.entree['in-property-address']}</small>
                            </li>
                        )}
                        {localInventory?.sortie && (
                            <li>
                                <strong>Sortie</strong><br />
                                {localInventory.sortie['out-start']}<br />
                                <small>{localInventory.sortie['out-property-address']}</small>
                            </li>
                        )}
                        {localInventory?.report && (
                            <li>
                                <strong>Rapport</strong><br />
                                {localInventory.report}
                            </li>
                        )}
                    </ul>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-secondary" onClick={handleClose}>
                        Fermer
                    </Button>
                    <Button variant="primary" onClick={validateAndSendInventory}>
                        Envoyer maintenant
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}